import { isNotNullOrUndefined, isObject, isString } from '@vy/utils';
import type { FieldPath } from 'react-hook-form';
import { ERROR_NOTIFICATION_TYPES } from '../../../../../components/design/ErrorNotification/error-notification-types/error-notification-type';
import type { PlanInputForm } from '../CreatePlanForm/create-plan-form-types/plan-input-form';
import type {
  ErrorObject,
  ErrorMessages,
} from './create-plan-error-notification-types/create-plan-error-notification-types';

export function extractErrorMessages(
  errorObject: ErrorObject,
  parentPath: string[] = [],
  visited = new WeakSet(),
): ErrorMessages[] {
  const errorMessages: ErrorMessages[] = [];

  if (visited.has(errorObject)) {
    return errorMessages;
  }

  visited.add(errorObject);

  for (const key in errorObject) {
    const value = errorObject[key];
    const currentPath = [...parentPath, key];

    if (shouldRecurse(value)) {
      errorMessages.push(...extractErrorMessages(value, currentPath, visited));
    } else if (isErrorMessageKey(key, value)) {
      const error = createErrorMessage(value, currentPath);
      errorMessages.push(error);
    }
  }

  return errorMessages;
}

function shouldRecurse(value: ErrorObject): boolean {
  return isNotNullOrUndefined(value) && isObject(value);
}

function isErrorMessageKey(key: string, value: ErrorObject): boolean {
  return key === 'message' && isString(value);
}

function createErrorMessage(value: string, currentPath: string[]): ErrorMessages {
  return {
    type: ERROR_NOTIFICATION_TYPES.Descriptor,
    message: formatErrorMessage(currentPath, value),
    fieldPath: currentPath.join('.') as FieldPath<PlanInputForm>,
  };
}

function formatErrorMessage(currentPath: string[], value: string) {
  return `${currentPath.join(' ').replace('message', '')} ${value}`;
}
